export const getApiUrl = (url, version = 1) =>
  version
    ? `${import.meta.env.VITE_API_URL}v${version}/${url}`
    : `${import.meta.env.VITE_API_URL}${url}`;

export const parseArrayToObjectWithSpecifedKey = (array, key) => {
  let object = {};
  array.forEach((item) => {
    object[typeof key === "function" ? key(item) : item[key]] = item;
  });
  return object;
};

export const setRequestStatusReducer = (state, requestName, value, meta) => {
  let reducerKey = meta && meta.reducerKey ? meta.reducerKey : false;

  return reducerKey
    ? state.setIn([requestName, reducerKey], value)
    : state.set(requestName, value);
};

export const serializeObjectToURLParameters = (obj) =>
  Object.keys(obj)
    .map((key) => {
      if (Array.isArray(obj[key]))
        return obj[key]
          .map((item, index) => `${key}[]=${encodeURIComponent(item)}`)
          .join("&");
      return key + "=" + encodeURIComponent(obj[key]);
    })
    .join("&");

export const sanitizeBody = (obj) => {
  for (var key in obj) {
    if (Array.isArray(obj[key])) obj[key] = obj[key].filter((item) => item);
  }

  return obj;
};
